export class AzimuthHelper {
  
    static readonly directionAngles = {
      N: 0, NE: 45, E:90, SE: 135, S: 180, SW: 225, W: 270, NW: 315
    }
  
    static readonly directions = ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW']
  
    static getOppositeDirection = ( direction : string ) => {
      return AzimuthHelper.directions[(AzimuthHelper.directions.findIndex(d=>d==direction)+4)%8]
    }
  
    static getCornerDirections = ( direction : string ) => {
      const index = AzimuthHelper.directions.findIndex(d=>d==direction)
      return [AzimuthHelper.directions[(index+1)%8],AzimuthHelper.directions[(index+7)%8]]
    }
  
    static readonly getCompassDirectionTitle = ( directionAbbr : string ) => {
      switch (directionAbbr) {
        case 'N': return 'North'
        case 'NE': return 'North East'
        case 'E': return 'East'
        case 'SE': return 'South East'
        case 'S': return 'South'
        case 'SW': return 'SouthWest'
        case 'W': return 'West'
        case 'NW': return 'North West'
        default: return directionAbbr
      }
    }

    static getOppositeAngle = ( angle : number ) => (angle+180)%360
  }